import { get, post, del, put, postForm, putForm } from 'utils/methods';

// D E S I G N   L I B R A R Y  &  V A R I A N T
export function getDesignLibraryVariantsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}libraries/design-variants`, data, headers);
}

export function getDesignLibraryApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}libraries`, data, headers);
}

export function loadDesignLibrarySettingsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}settings`, data, headers);
}

export function getLibraryApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}libraries`, data, headers);
}
export function addNewDesignLibraryApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/library`, data, headers);
}

export function updateDesignLibraryTranslateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/library/name-translate`, data, headers);
}

export function editDesignLibraryApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/library`, data, headers);
}

export function deleteDesignLibraryApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/library`, data, headers);
}

export function toggleDesignLibraryItemStateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/library/design-variant-state`, data, headers);
}

export function addNewDesignVariantApi(data, headers) {
    return postForm(`${process.env.REACT_APP_REST_ORDERS}commands/library/design-variant`, data, headers);
}

export function editDesignVariantApi(data, headers) {
    return putForm(`${process.env.REACT_APP_REST_ORDERS}commands/library/design-variant`, data, headers);
}
// D E S I G N   L I B R A R Y  &  V A R I A N T
export function deleteDesignVariantApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/library/design-variant`, data, headers);
}
// D E S I G N   L I B R A R Y


// D E S I G N   L I B R A R Y   S E T T I N G S
export function getDesignLibrarySettingsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}settings`, data, headers);
}

export function editDesignLibrarySettingsApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/setting`, data, headers);
}

export function deleteDesignLibrarySettingsApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/setting`, data, headers);
}

export function addDesignLibrarySettingsApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/setting`, data, headers);
}
// D E S I G N   L I B R A R Y   S E T T I N G S
